import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import API from "../../../src/apiService";
import { Formik, Form } from "formik";
import * as Yup from "yup";
const SignupSchema = Yup.object().shape({
  uang: Yup.number().required("Nama harus diisi"),
  // username: Yup.string().required("Nama pengguna harus diisi"),
  // password: Yup.string().required("Password tidak boleh kosong"),
  // confirmedPassword: Yup.string()
  //   .required("Password is required")
  //   .oneOf([Yup.ref("password"), null], "Passwords must match")
});

export default class ModalPelayanan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total: Number(
        this.props.total.reduce((a, b) => a + b, 0).toFixed(1)
      ),
      charge: 0,
      payments: "",
      keterangan: 'Kembalian',
      color: ""
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate = () => {
    // console.log(this.props, 'berubah')
    if (this.state.total !== Number(
      this.props.total.reduce((a, b) => a + b, 0).toFixed(1)
    ) && this.props.show) {
      this.setState({
        total: Number(
          this.props.total.reduce((a, b) => a + b, 0).toFixed(1))
      })
    }
  }

  handleChange(e) {
    let total = Number(this.props.total.reduce((a, b) => a + b, 0).toFixed(1));
    let charge = parseInt(total) - parseInt(e.target.value);
    let keterangan = this.state.keterangan;
    let color = this.state.color;
    if (charge < 0) { keterangan = "Kembalian"; color = "green" } else { keterangan = "Kekurangan"; color = "red" }
    this.setState({
      [e.target.name]: e.target.value,
      charge: charge,
      keterangan: keterangan,
      color: color
    });
  }

  handleSubmit = async () => {
    let param = {
      id: this.props.data.num_of_ticket,
      payment: this.state.payments,
      bon: this.state.charge > 0 ? this.state.charge : 0,
      paid: this.state.charge <= 0 ? true : false
    };
    const res = await API.put("registration/payment/update", param);
    if (res.code === 200) {
      this.props.onHide();
      this.props.close();
    }
    // console.log(param);
  }
  render() {
    // console.log(this.props);
    return (
      <Modal {...this.props} aria-labelledby="modal">
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Layani Pembayaran</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            uang: this.state.payments,
            total: this.state.total,
            charge: this.state.charge
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            this.handleSubmit()
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <ModalBody>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Total
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="total"
                        id="total"
                        value={this.state.total.toLocaleString()}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Bayar
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="payments"
                        id="payments"
                        autoComplete="off"
                        value={this.state.payments}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                    style={{ color: this.state.color }}
                  >
                    {this.state.keterangan}
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm"
                        style={{ color: this.state.color }}
                        type="text"
                        name="charge"
                        id="charge"
                        value={Math.abs(this.state.charge)}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      onClick={this.props.onHide}
                      className="btn btn-outline-secondary"
                    >
                      Batal
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Simpan
                    </button>
                  </div>
                </div>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  }
}
